import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import "./HamburgerMenu.css";

interface MenuItem {
  id: string;
  label: string;
  path: string;
  icon: string;
}

interface HamburgerMenuProps {
  isOpen: boolean;
  onClose: () => void;
  hasRecentNotifications?: boolean;
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ 
  isOpen, 
  onClose,
  hasRecentNotifications = false,
}) => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const menuItems: MenuItem[] = [
    {
      id: "vitrine",
      label: "Vitrine",
      path: "/",
      icon: "🏪",
    },
    {
      id: "meus-materiais",
      label: "Meus Materiais",
      path: "/meus-materiais",
      icon: "📚",
    },
    {
      id: "materiais-gratuitos",
      label: "Materiais Gratuitos",
      path: "/materiais-gratuitos",
      icon: "🎁",
    },
    {
      id: "notificacoes",
      label: "Notificações",
      path: "/notificacoes",
      icon: "🔔",
    },
    {
      id: "suporte",
      label: "Suporte",
      path: "/suporte",
      icon: "🆘",
    },
    {
      id: "perfil",
      label: "Perfil",
      path: "/perfil",
      icon: "👤",
    },
  ];

  const handleItemClick = (path: string) => {
    navigate(path);
    onClose();
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="menu-overlay" onClick={onClose}></div>}

      {/* Menu Sidebar */}
      <div className={`hamburger-menu ${isOpen ? "open" : ""}`}>
        <div className="menu-header">
          <img
            src="/turminha_logo.png"
            alt="Turminha Educa"
            className="menu-logo"
          />
          <button
            className="close-button"
            onClick={onClose}
            aria-label="Fechar menu"
          >
            ✕
          </button>
        </div>

        <nav className="menu-nav">
          <ul className="menu-list">
            {menuItems.map((item) => (
              <li key={item.id} className="menu-item">
                <button
                  className="menu-link"
                  onClick={() => handleItemClick(item.path)}
                >
                  <span className="menu-icon">{item.icon}</span>
                  <span className="menu-label">{item.label}</span>
                  {item.id === "notificacoes" && hasRecentNotifications && (
                    <span className="menu-notification-badge"></span>
                  )}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        <div className="menu-footer">
          <button className="logout-button" onClick={handleLogout}>
            <span className="menu-icon">🚪</span>
            <span className="menu-label">Sair</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default HamburgerMenu;
